import axios from 'axios';

class RegistrationFundsCount {
    static cache = null;
    static fetching = null;

    constructor(element) {
        this.blockElement = element;
        this.apiUrl = this.blockElement.dataset.api || null;
        this.displayType = this.blockElement.dataset.displayType || 'funds';
        // get translated "osób" from dataset
        this.usersLabel = this.blockElement.dataset.usersLabel || 'osób';
    }

    init() {
        if (!this.apiUrl) {
            console.error('Brak atrybutu data-api na bloku:', this.blockElement);
            return;
        }
        this.fetchData();
    }

    async fetchData() {
        try {
            let data;

            if (RegistrationFundsCount.cache) {
                data = RegistrationFundsCount.cache;
            } else if (RegistrationFundsCount.fetching) {
                data = await RegistrationFundsCount.fetching;
            } else {
                RegistrationFundsCount.fetching = axios.get(this.apiUrl)
                    .then(response => {
                        RegistrationFundsCount.cache = response.data;
                        return response.data;
                    })
                    .finally(() => {
                        RegistrationFundsCount.fetching = null;
                    });
                data = await RegistrationFundsCount.fetching;
            }

            let value = 0;
            if (this.displayType === 'count') {
                value = (data?.users ?? 0) + ' ' + this.usersLabel; // append translation
            } else if (this.displayType === 'funds') {
                value = data?.totals ?? 0;
                value = new Intl.NumberFormat('pl-PL', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                }).format(value) + ' zł';
            }

            this.blockElement.innerHTML = `<strong>${value}</strong>`;
        } catch (error) {
            console.error(`Błąd podczas pobierania danych z ${this.apiUrl}:`, error.message);
            this.blockElement.innerHTML = `<strong>${this.displayType === 'funds' ? '0 zł' : '0 ' + this.usersLabel}</strong>`;
        }
    }
}


document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('.registration-funds-count-block')
        .forEach((blockElement) => new RegistrationFundsCount(blockElement).init());
});